module.exports = __webpack_public_path__ + "img/qc.a136f31c.jpg";